import { Outlet, createRoute, redirect } from '@tanstack/react-router'

import { entityRoute } from '@/app/routes/entity-route'
import { AreaSidebar, ProductGuard, ProductLayout } from '@/app/routes/area-layout'

export function LearningLayout() {
  return (
    <ProductGuard product="learning">
      <ProductLayout sidebar={<AreaSidebar area="learning" />}>
        <Outlet />
      </ProductLayout>
    </ProductGuard>
  )
}

export const learningRoute = createRoute({
  getParentRoute: () => entityRoute,
  path: 'learning',
  component: LearningLayout,
})

export const learningIndexRoute = createRoute({
  getParentRoute: () => learningRoute,
  path: '/',
  beforeLoad: ({ params }) => {
    throw redirect({
      to: '/$entityId/learning/my-learning',
      params: { entityId: params.entityId },
      replace: true,
    })
  },
})
